import httpUtil from "../assets/script/utils/http";

const state = {
  userToken: "",
  userLevel: "",
  giftInfo: { givesource: "", days: 0 }
};
const getters = {
  // ...
};
const mutations = {
  setUserInfo(state, payload) {
    state.userToken = payload;
  },
  setUserLevel(state, payload) {
    state.userLevel = payload;
  },
  setGiftInfo(state, info) {
    state.giftInfo = Object.assign(state.giftInfo, info);
  }
};

const actions = {
  publicQrCode(ctx, params) {
    return httpUtil.get("/account/publicQrCode", params);
  },
  publicQrCodeState(ctx, params) {
    return httpUtil.get("/account/publicQrCodeState", params);
  },
  publicLogin(ctx, params) {
    return httpUtil.get("/account/publicLogin", params);
  },
  userLogin(ctx, params) {
    return httpUtil.post("/account/login", params);
  },
  getAiUserInfo(ctx, params) {
    return httpUtil.post("/ai/aiInfo", params);
  },
  getReffInfo(ctx, params) {
    return httpUtil.post("/ai/AiSetRefer", params);
  },
  getRegisterGiveRule(ctx, params) {
    return httpUtil.get("/ai/RegisterGiveRule", params);
  },
  getRegisterGive(ctx, params) {
    return httpUtil.post("/ai/RegisterGive", params);
  },
  getUsersVisitDay(ctx, params) {
    return httpUtil.post("/ai/UsersVisitDay", params);
  },
  getForGetCode(ctx, params) {
    return httpUtil.get("/account/SendCode", params);
  },
  getUserReset(ctx, params) {
    return httpUtil.post("/account/UpdatePassword", params);
  },
  getUserRegister(ctx, params) {
    return httpUtil.post("/account/RegisterConfirm", params);
  },
  getMobileVerifyCode(ctx, params) {
    return httpUtil.get("/account/MobileVerifyCode", params);
  },
  getMobileCheck(ctx, params) {
    return httpUtil.get("/account/MobileCheck", params);
  },
  getUserLogin(ctx, params) {
    return httpUtil.get("/account/_mediaLogin", params);
  },
  async AGetPushMessage(context, params) {
    return await httpUtil.post("/ai/getPushMessage", params);
  },
  async AgetLimitedTime(context, params) {
    return await httpUtil.post("/ai/getLimitedTime", params);
  },
  async AGetCountDown(context, params) {
    return await httpUtil.get("/ai/getCountDown", params);
  },
  async AGetGuid(context, params) {
    return await httpUtil.get("/account/GetNugd", params);
  },
  async AGetVcodeImage(context, params) {
    return await httpUtil.get("/account/vcode", params);
  },
  async AGetCheckCode(context, params) {
    return await httpUtil.get("/account/CheckCode", params);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
